import { render, staticRenderFns } from "./CollectionPage.vue?vue&type=template&id=9e96bec6&scoped=true"
import script from "./CollectionPage.vue?vue&type=script&lang=js"
export * from "./CollectionPage.vue?vue&type=script&lang=js"
import style0 from "./CollectionPage.vue?vue&type=style&index=0&id=9e96bec6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e96bec6",
  null
  
)

export default component.exports